import classNames from 'classnames';
import type { FC } from 'react';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
  desktopSmall?: boolean;
  remainingDays: number;
  small?: boolean;
}

export const ExpiredBox: FC<Props> = (props) => (
  <span
    className={classNames(
      'header__expired-box',
      props.remainingDays <= 0 && 'header__expired-box--expired',
      props.small && 'block',
      props.desktopSmall && 'header__expired-box--desktop-small',
      props.className,
    )}
  >
    {props.children}
  </span>
);
